import React from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  const handleFreeKundli = () => navigate('/kundli');   // TODO: add this route/page when ready
  const handleBookPooja = () => navigate('/pooja');      // TODO: add this route/page when ready
  const handleMoonTracker = () => navigate('/moon');     // TODO: add this route/page when ready
  const handleChat = () => navigate('/chat');

  return (
    <div className="home-container">
      <div className="features-preview">
        <div className="feature-preview kundli" onClick={handleFreeKundli}>
          <div className="preview-icon">🔮</div>
          <div className="preview-text">Free Kundli</div>
        </div>
        <div className="feature-preview pooja" onClick={handleBookPooja}>
          <div className="preview-icon">📖</div>
          <div className="preview-text">Book Pooja</div>
        </div>
        <div className="feature-preview moon" onClick={handleMoonTracker}>
          <div className="preview-icon">🌙</div>
          <div className="preview-text">Moon Track</div>
        </div>
      </div>

      <div className="cta-chat-container">
        <button className="cta-chat-button" onClick={handleChat}>
          🙏 Chat with Guru ji
        </button>
        <div className="cta-subtext">
          Seek personalized Vedic guidance, my child. According to the stars, answers await. ✨
        </div>
      </div>

      <div className="feature-cards">
        <button className="feature-card kundli" onClick={handleFreeKundli}>
          <div className="feature-title">🔮 PERSONALIZED KUNDLI</div>
          <div className="feature-desc">Your cosmic DNA analysis</div>
        </button>

        <button className="feature-card pooja" onClick={handleBookPooja}>
          <div className="feature-title">📖 SACRED POOJA</div>
          <div className="feature-desc">Divine blessing rituals</div>
        </button>

        <button className="feature-card moon" onClick={handleMoonTracker}>
          <div className="feature-title">🌙 LUNAR GUIDANCE</div>
          <div className="feature-desc">Moon phase insights</div>
        </button>
      </div>

      <div className="secondary-chat">
        <button className="secondary-chat-button" onClick={handleChat}>
          💬 Start a new consultation
        </button>
      </div>
    </div>
  );
}

export default Home;
